// Angular
import { Component } from '@angular/core';
// Metronic

@Component({
  selector: 'kt-scroll-top',
  templateUrl: './scroll-top.component.html'
})
export class ScrollTopComponent {
  // Public properties
  scrollTopOptions: any = {
    offset: 300,
    speed: 600
  };
}
